import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { uniqueKeywords } from '@/features/editor/components/knowledge/utils'

type KeywordEditorProps = {
  keywords: string[]
  onChange: (next: string[]) => void
}

export function KeywordEditor({ keywords, onChange }: KeywordEditorProps) {
  const [input, setInput] = useState('')

  function addFromInput() {
    const raw = input.trim()
    if (!raw) return

    const parts = raw
      .split(/[,，]/g)
      .map((s) => s.trim())
      .filter(Boolean)

    const next = uniqueKeywords([...(keywords ?? []), ...parts])
    onChange(next)
    setInput('')
  }

  function removeKeyword(k: string) {
    onChange((keywords ?? []).filter((x) => x !== k))
  }

  return (
    <div className='space-y-2'>
      <div className='text-muted-foreground text-xs font-medium'>关键词</div>

      <div className='flex flex-wrap gap-2'>
        {(keywords ?? []).length === 0 ? (
          <div className='text-muted-foreground text-xs'>暂无关键词</div>
        ) : (
          (keywords ?? []).map((k) => (
            <span
              key={k}
              className='bg-background border-border inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs'
            >
              <span className='max-w-[220px] truncate'>{k}</span>
              <button
                type='button'
                onClick={() => removeKeyword(k)}
                className='text-muted-foreground hover:bg-muted/30 hover:text-foreground rounded-full px-1 transition'
                aria-label='remove keyword'
                title='移除'
              >
                ×
              </button>
            </span>
          ))
        )}
      </div>

      <div className='flex items-center gap-2'>
        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
              addFromInput()
            }
          }}
          placeholder='输入关键词，回车添加；支持逗号分隔'
          className='bg-background border-border placeholder:text-muted-foreground hover:bg-background/80 focus-visible:border-ring focus-visible:ring-ring/30 w-full rounded-lg border px-3 py-2 text-sm transition outline-none focus-visible:ring-2'
        />

        <Button type='button' onClick={addFromInput} className='shrink-0'>
          添加
        </Button>
      </div>
    </div>
  )
}
